import R_ImageGrid from './R_ImageGrid';

const init = () => {
    return class R_ImageObstacle extends R_ImageGrid {
        constructor(obj) {
            super(obj);

            this._hit = false;
        }
    };
};


export default init();



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/runner/dev/child/image/R_ImageObstacle.js